import { render, staticRenderFns } from "./ProductRateCalibration.vue?vue&type=template&id=27352b74"
import script from "./ProductRateCalibration.vue?vue&type=script&lang=js"
export * from "./ProductRateCalibration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports